import React from 'react'
import { Modal } from 'rsuite'

import { AddToEventButton as MyButton } from '../../Activity/ActivityStyledComponents'
import { ErrorCross } from '../../Icons'
import { colors } from '../../Styles/common-styles'
import styles from '../../AdminPanel/styles'

const UserIsAdmin = ({ setModalVisible }) => (
  <>
    <Modal.Header>
      <Modal.Title style={styles.modalTitle1}>
        Sorry, this user has admin role
      </Modal.Title>
      <Modal.Title style={styles.modalTitle2}>
        You can't delete him
      </Modal.Title>
    </Modal.Header>
    <Modal.Body style={styles.modalBody}>
      <ErrorCross stroke={colors.errorRed} />
    </Modal.Body>
    <Modal.Footer style={styles.modalFooter}>
      <MyButton reverse onClick={() => setModalVisible(false)}>Close</MyButton>
    </Modal.Footer>
  </>
)

export default UserIsAdmin
